"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PinSpotlight = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_PinSpotlight_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 11,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0h5.264a2.998 2.998 0 0 0-.593 1H6.5v5.5A.5.5 0 0 1 6 7a1.5 1.5 0 0 0-1.5 1.5h7A1.5 1.5 0 0 0 10 7a.5.5 0 0 1-.5-.5V3.659c.256.385.599.707 1 .94V6.05a2.5 2.5 0 0 1 2 2.45v.25a.75.75 0 0 1-.75.75H8.907l-.374 6a.532.532 0 0 1-1.062.001L7.095 9.5H4.25a.75.75 0 0 1-.75-.75V8.5a2.5 2.5 0 0 1 2-2.45V1h-1a.5.5 0 0 1 0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2a2 2 0 1 1 4.001 0A2 2 0 0 1 10 2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_PinSpotlight_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = PinSpotlight;
exports["default"] = _default;